import _ from 'underscore';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { MixedContentItemDefinition } from '../../../contentDefinitionInterfaces/ContentDefinitionsTypes';

export namespace FilterByTypeDropdownHelpers {
  export const getContentDefinitions = (
    useShowWorkbooksAsViews: boolean,
    showWorkbooksAsViews: boolean,
    flowsEnabled: boolean,
    hiddenContentTypes: ReadonlyArray<ExplorableItemType> = [],
    contentItemDefinitions: MixedContentItemDefinition[]
  ): MixedContentItemDefinition[] => {
    const items: MixedContentItemDefinition[] = [];

    for (const typeDef of contentItemDefinitions) {
      if (
        (typeDef.itemType === 'flow' && !flowsEnabled) ||
        (typeDef.itemType === 'metric' && !FeatureFlags.metricsSpaceEnabled) ||
        (typeDef.itemType === 'lens' && !FeatureFlags.nlplensContentTypeEnabled) ||
        (typeDef.itemType === 'publishedConnection' && !FeatureFlags.publishedConnectionContentManagementEnabled) ||
        (typeDef.itemType === 'collection' && !FeatureFlags.useCollectionsFavorites) ||
        (hiddenContentTypes.length && _.contains(hiddenContentTypes,typeDef.itemType))) {
        continue;
      }

      if (useShowWorkbooksAsViews) {
        if (!showWorkbooksAsViews && typeDef.itemType === 'view') {
          // Showing workbooks only.
          continue;
        } else if (showWorkbooksAsViews && typeDef.itemType === 'workbook') {
          // Showing views instead.
          continue;
        }
      }
      items.push(typeDef);
    }

    return items;
  };

  export const showingViewsOrWorkbooks = (currentTypeFilters: ReadonlyArray<ExplorableItemType>): boolean => {
    return _.some(currentTypeFilters, (contentType: ExplorableItemType) => {
      return contentType === 'workbook'
        || contentType === 'view';
    });
  };

  export const isCurrentlyFilteredContentType = (value: string, currentTypeFilters: ReadonlyArray<ExplorableItemType>) => {
    return _.some(currentTypeFilters, (selectedItem) => {
      if (selectedItem === 'dataconnection') {
        return value === 'datasource';
      }
      return selectedItem === value;
    });
  };

}
